import Index from "@/pages/Index";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import BlogAdmin from "@/pages/admin/BlogAdmin";
import AdminLogin from "@/pages/admin/Login";
import Demo from "@/pages/demo/Index";
import PPCMarketing from "@/pages/services/ppc-marketing";
import EmailMarketing from "@/pages/services/email-marketing";
import SEO from "@/pages/services/seo";
import LeadGenerationSales from "@/pages/services/lead-generation-sales";
import WebDevelopment from "@/pages/services/web-development";
import Ecommerce from "@/pages/services/ecommerce";
import NoCodeDevelopment from "@/pages/services/nocode-development";
import UXUIDesign from "@/pages/services/ux-ui";
import WorkflowAutomation from "@/pages/services/workflow-automation";
import DataIntegration from "@/pages/services/data-integration";
import AIAgents from "@/pages/services/ai-agents";
import Analytics from "@/pages/services/analytics";
import CROTesting from "@/pages/services/cro-testing";
import HowItWorks from "@/pages/HowItWorks";
import WhoWeHelp from "@/pages/WhoWeHelp";
import ServiceBusinessesLanding from "@/pages/landing/ServiceBusinesses";
import EducationLanding from "@/pages/landing/Education";
import RestaurantsLanding from "@/pages/landing/Restaurants";
import Technology from "@/pages/industries/technology";
import Education from "@/pages/industries/education";
import ServiceBusinesses from "@/pages/industries/service-businesses";
import EcommerceIndustry from "@/pages/industries/ecommerce";
import Webinars from "@/pages/Webinars";
import Tools from "@/pages/Tools";
import CaseStudies from "@/pages/CaseStudies";
import TechnologyCaseStudies from "@/pages/case-studies/technology/Index";
import CloudTechSolutionsCase from "@/pages/case-studies/technology/cloudtech-solutions";
import EcommerceCaseStudies from "@/pages/case-studies/ecommerce/Index";
import ServiceBusinessesCaseStudies from "@/pages/case-studies/services/Index";
import EducationCaseStudies from "@/pages/case-studies/education/Index";

export interface RouteConfig {
  path: string;
  element: React.ComponentType;
}

export const routes: RouteConfig[] = [
  { path: "", element: Index },
  { path: "contact", element: Contact },
  { path: "demo", element: Demo },
  { path: "about", element: About },
  { path: "blog", element: Blog },
  { path: "blog/:slug", element: BlogPost },
  { path: "admin/login", element: AdminLogin },
  { path: "admin/blog", element: BlogAdmin },
  { path: "services/ppc-marketing", element: PPCMarketing },
  { path: "services/email-marketing", element: EmailMarketing },
  { path: "services/seo", element: SEO },
  { path: "services/lead-generation-sales", element: LeadGenerationSales },
  { path: "services/web-development", element: WebDevelopment },
  { path: "services/ecommerce", element: Ecommerce },
  { path: "services/nocode-development", element: NoCodeDevelopment },
  { path: "services/ux-ui", element: UXUIDesign },
  { path: "services/workflow-automation", element: WorkflowAutomation },
  { path: "services/data-integration", element: DataIntegration },
  { path: "services/ai-agents", element: AIAgents },
  { path: "services/analytics", element: Analytics },
  { path: "services/cro-testing", element: CROTesting },
  { path: "how-it-works", element: HowItWorks },
  { path: "who-we-help", element: WhoWeHelp },
  { path: "service-businesses", element: ServiceBusinessesLanding },
  { path: "education", element: EducationLanding },
  { path: "restaurants", element: RestaurantsLanding },
  { path: "industries/technology", element: Technology },
  { path: "industries/education", element: Education },
  { path: "industries/service-businesses", element: ServiceBusinesses },
  { path: "industries/ecommerce", element: EcommerceIndustry },
  { path: "webinars", element: Webinars },
  { path: "tools", element: Tools },
  { path: "case-studies", element: CaseStudies },
  { path: "case-studies/technology", element: TechnologyCaseStudies },
  { path: "case-studies/technology/cloudtech-solutions", element: CloudTechSolutionsCase },
  { path: "case-studies/ecommerce", element: EcommerceCaseStudies },
  { path: "case-studies/services", element: ServiceBusinessesCaseStudies },
  { path: "case-studies/education", element: EducationCaseStudies },
];